var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ptend_gao"},[_c('div',{staticClass:" ptend_div"},[_c('img',{attrs:{"src":require("../../../image/wu_b.png")}}),_c('p',[_vm._v(_vm._s(_vm.noTitle))]),_c('span',[_vm._v(_vm._s(_vm.noTxt))])])])}
var staticRenderFns = []

export { render, staticRenderFns }